export default {
  guides: {
    sectionTitle: "In-Depth USFans Guides",
    sectionSubtitle: "Ten practical pillar guides covering everything from shopping safely to shipping, coupons, legitimacy and privacy.",
    readMore: "Read the guide",
    items: [
      {
        title: "USFans Shopping Guide: How to Buy With Confidence",
        desc: "A step-by-step walkthrough for browsing USFans, choosing the right product and completing a purchase safely.",
      },
      {
        title: "USFans Spreadsheet: The Complete Guide",
        desc: "Understand what the USFans Spreadsheet is, how its categories work and how to navigate it quickly.",
      },
      {
        title: "USFans Review: Features, Pros & Cons",
        desc: "An honest look at the platform's features, advantages, limitations and the things to watch out for.",
      },
      {
        title: "USFans Shipping Cost: Complete Price Guide",
        desc: "Learn which factors influence shipping prices and how to estimate delivery costs for your region.",
      },
      {
        title: "USFans Coupon: How to Find Real Offers",
        desc: "A practical guide to finding genuine promotions and understanding how USFans coupons actually work.",
      },
      {
        title: "USFans Discount Code: How to Verify Deals",
        desc: "How to check whether a discount code is valid before checkout and avoid expired or fake offers.",
      },
      {
        title: "USFans Warehouse: Storage & Fulfillment Guide",
        desc: "Everything you need to know about warehouse storage, order processing and fulfillment timelines.",
      },
      {
        title: "Is USFans Legit? What to Know Before Buying",
        desc: "How to evaluate legitimacy, trust and security signals before you place an order.",
      },
      {
        title: "USFans Safety: Protect Your Account & Privacy",
        desc: "Practical recommendations for keeping your account, payments and personal information safe.",
      },
      {
        title: "USFans Privacy: How Your Data Is Handled",
        desc: "A clear overview of privacy considerations and how to protect your personal information while shopping.",
      },
    ],
    detail: {
      pointsTitle: "What to Keep in Mind",
      points: [
        "Always verify current prices, sizes and availability on the main store before purchasing.",
        "Check shipping cost and estimated delivery for your specific region.",
        "Confirm any coupon or discount code directly at checkout before relying on it.",
        "Use official or trusted sources and keep your personal and payment information safe.",
      ],
      relatedTitle: "More USFans Guides",
      visitMain: "Visit the Main Website",
      backHome: "Back to Home",
    },
  },
};